<script>
  export let products;
  export let onRiddleDone;
  let openWindow = null;
  let riddleStatus = 0;
  let riddleValue = "";
  let wizardNum = 0;

  function resetRiddle() {
    openWindow = null;
    riddleStatus = 0;
    wizardNum = 0;
    riddleValue = "";
    onRiddleDone();
  }
</script>

{#if openWindow != null}
  <div class="window_bg">
    {#if openWindow == "p2"}
      <div class="window">
        <div class="title-bar">
          <div class="title-bar-text">Product herstellen</div>
          <div class="title-bar-controls">
            <button aria-label="Minimize"></button>
            <button aria-label="Maximize"></button>
            <button aria-label="Close"></button>
          </div>
        </div>
        <div class="window-body">
          {#if riddleStatus == 0 || riddleStatus == -1}
            <b>Oh nee!</b>
            <p>
              De eerste was makkelijk, maar nu hebben we enkel een fragment. Aan
              jouw om te luisteren en daarna op volgende te klikken!
            </p>

            {#if wizardNum == 0}
              <div>
                <audio controls>
                  <source src="MegaDeals_Piet.mp3" type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
                <br />
                <button
                  on:click={() => {
                    wizardNum = 1;
                  }}>Volgende</button
                >
              </div>
            {/if}
            {#if wizardNum == 1}
              <div class="field-row">
                <label for="text21">Hoe vaak komt het woord "Piet" voor?</label>
                <input
                  id="text21"
                  autofocus
                  bind:value={riddleValue}
                  type="text"
                />
                <button
                  on:click={() => {
                    if (riddleValue.toLowerCase().trim() == "5") {
                      riddleStatus = 1;
                    } else {
                      riddleStatus = -1;
                    }
                  }}>Controleren</button
                >
              </div>
              <button
                on:click={() => {
                  wizardNum = 0;
                }}>Vorige</button
              >
            {/if}

            {#if riddleStatus == -1}
              <b>Helaas, dat is niet goed...</b>
            {/if}
          {:else}
            <b>Goed gedaan!</b> Mega-Deals wordt mega beroemd! Het lijkt er op
            dat de inventaris weer in orde is, wellicht kan je nu bij berichten
            kijken?
            <br />
            <button
              on:click={() => {
                resetRiddle();
                products[3].status = 1;
                products[3].name = "CD Mega-Deals Piet";
              }}>Afsluiten</button
            >
          {/if}
        </div>
      </div>
    {/if}
    {#if openWindow == "p1"}
      <div class="window">
        <div class="title-bar">
          <div class="title-bar-text">Product herstellen</div>
          <div class="title-bar-controls">
            <button aria-label="Minimize"></button>
            <button aria-label="Maximize"></button>
            <button aria-label="Close"></button>
          </div>
        </div>
        <div class="window-body">
          {#if riddleStatus == 0 || riddleStatus == -1}
            <b>Oh nee!</b>
            <p>
              Het product is verkeerd opgeslagen in onze database! Ik zou graag
              willen zeggen: "probeer het later nog eens", maar bij Mega-Deals
              zijn we geen lampzwanzers en we fixen alles zelf. Boos-Inventaris
              2024 kan dit automatisch voor je herstellen, maar je was te gierig
              om een nieuwe licentie aan te schaffen. Dit is wat Boos-Inventaris
              2003 kon herstellen:
            </p>

            <p>
              Ik ben rond en ik hou van muziek. Ik wordt in de auto gebruikt en
              wordt gemaakt door artiesten en studios. Wat ben ik?
            </p>

            <div class="field-row">
              <label for="text21">Wat is het product?</label>
              <input
                autofocus
                id="text21"
                bind:value={riddleValue}
                type="text"
              />

              <button
                on:click={() => {
                  if (riddleValue.toLowerCase().trim() == "cd") {
                    riddleStatus = 1;
                  } else {
                    riddleStatus = -1;
                  }
                }}>Controleren</button
              >
            </div>
            {#if riddleStatus == -1}
              <b>Helaas, dat is niet goed...</b>
            {/if}
          {:else}
            <b>Goed gedaan!</b> Nu kan iedereen weer Frans Bouwer kopen!
            <br />
            <button
              on:click={() => {
                resetRiddle();
                products[2].status = 1;
                products[2].name = "CD Frans Bouwer";
              }}>Afsluiten</button
            >
          {/if}
        </div>
      </div>
    {/if}
  </div>
{/if}
<table>
  <thead>
    <tr>
      <th>Product</th>
      <th>Aantal</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    {#each products as product, idx}
      <tr>
        <td>{product.name}</td>
        <td>{product.quantity}</td>
        {#if product.status == 1}
          <td>OK</td>
        {:else}
          <td>
            Error: Corrupt!
            <button
              disabled={!(idx - 1 > 0 && products[idx - 1].status == 1)}
              on:click={() => {
                openWindow = product.toOpen;
                riddleStatus = 0;
              }}>Herstellen</button
            >
          </td>
        {/if}
      </tr>
    {/each}
  </tbody>
</table>

<style>
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: #f2f2f2;
  }
  .window_bg {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.5);
    display: flex; /* Establishes flex container */
    justify-content: center; /* Centers children horizontally */
    align-items: center; /* Centers children vertically */
  }
  .window_bg .window {
    max-width: 500px;
    width: 100%;
  }
</style>
